// removed by extract-text-webpack-plugin
module.exports = {"roles":"_1-IXsHRe9GUZkfvw8J_A4h","list":"_13Ii54RQU3sHjIAR7rJhbS"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Sections/Roles/style/Roles.pcss
// module id = 1159
// module chunks = 0